// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"634":"0ed98abb","777":"642c676e"}[chunkId] + ".chunk.js";
};